/** Keep in sync with api/hirelane/constants.js */
export const INTERVIEW_TYPES = [
  'Technical',
  'Architect',
  'HR',
  'Client',
  'Managerial',
  'Practical Evaluation',
  'Other'
];

export const INTERVIEW_MODES = ['Online', 'In Person', 'Phone'];

export const OUTCOME_NEXT_STEPS = [
  'Schedule Technical - Next Round',
  'Schedule Architect Round',
  'Schedule HR Round',
  'Schedule Client Round',
  'Schedule Practical Evaluation',
  'Compensation Discussion',
  'Keep on Hold',
  'Final Selection',
  'Reject Candidate'
];

export const INTERVIEW_OUTCOME_OPTIONS = ['Round Cleared', 'Hold', 'Rejected', 'Final Selected'];
